<template>
  <div>

    <b-container class="md-content ">
      <div class="md-header">Benutzerverwaltung</div>

      <b-row style="margin-top: 20px;">


        <!-- ROLE SECTION START -->
        <b-col md="auto" class="half-width">
          <!-- ROLE FILTER -->
          <div class="name-filter">
            <i class="fas fa-search"></i>
            <input class="adjust-input" v-model="roleFilter" placeholder="Rollen filtern" v-on:input="roleFilter = SanitizeInput(roleFilter);"/>
            <div class="button add fix-button-width" @click="openNewRoleWizard();">
              <div class="label">Neue Rolle anlegen</div>
            </div>
          </div>
          <!-- ROLE LIST -->
          <div class="list">
            <div class="scroll-content">
              <div class="list-entry" :key="index" v-for="(role, index) in rolesFilteredList" v-on:click="ToggleRole($event, null, role)" v-bind:class="{'selected': selectedRole === role}">
                <div class="picture" v-bind:style="{'background-color': role.color}">
                  <strong>{{role.letter}}</strong>
                </div>
                <div class="label">{{role.name}}</div>

                <div class="position-right">
                  <div class="picture text-center cursor-not-allowed" v-if="role.immutable">
                    <i class="fas fa-lock fa-sm cursor-not-allowed"></i>
                  </div>
                  <div class="picture text-center" v-if="!role.immutable" v-on:click="openDeleteModal($event, null, role)">
                    <i class="fas fa-trash fa-sm"></i>
                  </div>
                </div>
                <div class="position-right">
                  <div class="picture text-center" v-if="!role.immutable" v-on:click="openEditModal($event, null, role)">
                    <i class="fas fa-edit fa-sm"></i>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </b-col>
        <!-- ROLE SECTION END -->

        <!-- USER SECTION START -->
        <b-col md="auto" class="half-width">
          <!-- USER FILTER -->
          <div class="name-filter">
            <i class="fas fa-search"></i>
            <input class="adjust-input" v-model="userFilter" placeholder="Benutzer filtern" />
            <div class="button add fix-button-width" @click="openAddUserWizard();">
              <div class="label">Neuen Benutzer anlegen</div>
            </div>
          </div>
          <!-- USER LIST -->
          <div class="list">
            <div class="scroll-content">
              <div class="list-entry" :key="index" v-for="(user, index) in usersFilteredList" v-on:click="ToggleUser($event, null, user)" v-bind:class="{'selected': user.highlighted}">
                <div class="picture" v-bind:style="{background: GetProfilePictureCSS(user)}"></div>
                <div class="label">{{user.name}} &nbsp; <small class="label-small">{{user.email}}</small></div>
                <div class="position-right">
                  <div class="picture text-center" v-bind:style="{'background-color': user.role.color}" v-if="user.role">
                    <strong>{{user.role.letter}}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <!-- USER SECTION END -->

      </b-row>
    </b-container>




    <!-- MODAL CREATE ROLE -->
    <b-modal size="rolewizard" ref="modal-createrole" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true" >
      <div class="wizard-popup">
        <b-row>
          <b-col>
            <div class="header main">
              <div class="label">Neue Benutzerrolle anlegen</div>
            </div>
            <div class="close" v-on:click="hideModal('modal-createrole');">
              <i class="fas fa-times"></i>
            </div>
          </b-col>
        </b-row>
        <div>

            <b-container fluid>
                <div>
                    <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="cr1">
                        <b-form-input id="cr1" v-model="newRolename" type="text" v-on:input="newRolename = SanitizeInput(newRolename);"></b-form-input>
                    </b-form-group> 
                </div>
            </b-container>

            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next" @click="createRole($event)" v-if="!roleAlreadyExisting">
                            <div class="label">Speichern</div>
                        </div>
                        <div class="next text-muted"  v-if="roleAlreadyExisting">
                          <small>Diese Rolle existiert bereits!</small>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
      </div>
    </b-modal>

    <!-- MODAL EDIT ROLE -->
    <b-modal size="rolewizard" ref="modal-editrole" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true" >
      <div class="wizard-popup">
        <b-row>
          <b-col>
            <div class="header main">
              <div class="label">Benutzerrolle bearbeiten</div>
            </div>
            <div class="close" v-on:click="hideModal('modal-editrole');">
              <i class="fas fa-times"></i>
            </div>
          </b-col>
        </b-row>
        <div>

            <b-container fluid>
                <div>
                    <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="cr1">
                        <b-form-input id="cr1" v-model="newRolename" type="text" v-on:input="newRolename = SanitizeInput(newRolename);"></b-form-input>
                    </b-form-group> 
                </div>
            </b-container>

            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next" @click="updateRole($event)" v-if="!roleAlreadyExisting">
                            <div class="label">Speichern</div>
                        </div>
                        <div class="next text-muted"  v-if="roleAlreadyExisting">
                          <small>Diese Rolle existiert bereits!</small>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
      </div>
    </b-modal>

    <!-- MODAL DELETE ROLE -->
    <b-modal size="rolewizard" ref="modal-deleterole" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true" >
     <div class="wizard-popup">
        <b-row>
          <b-col>
            <div class="header main">
              <div class="label">Benutzerrolle löschen?</div>
            </div>
            <div class="close" v-on:click="hideModal('modal-deleterole');">
              <i class="fas fa-times"></i>
            </div>
          </b-col>
        </b-row>
        <div>

            <b-container fluid>
                <div>
                  Alle Benutzer mit dieser Rolle haben anschließend keine Zugriffsrechte mehr!
                  <br/>
                </div>
            </b-container>

            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next green" @click="deleteRole($event)">
                            <div class="label">Löschen</div>
                        </div>
                        <div class="button next" @click="hideModal('modal-deleterole')">
                            <div class="label">Abbrechen</div>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
      </div>
    </b-modal>


    <!-- MODAL NEW USERS -->
    <b-modal size="lg" ref="modal-adduser" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true" >
     <div class="wizard-popup">
        <b-row>
          <b-col>
            <div class="header main">
              <div class="label">Benutzer hinzufügen</div>
            </div>
            <div class="close" v-on:click="hideModal('modal-adduser');">
              <i class="fas fa-times"></i>
            </div>
          </b-col>
        </b-row>
        <div>

            <b-container fluid style="max-height: 400px;  overflow-y: auto;">
                <div>
                  
                  <b-row>
                      <b-col>
                          <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="availableEmployeesList" :fields="fields">
                            <template slot="pic" slot-scope="data">
                              <img class="pictureImg" v-bind:src="GetProfilePicture(data.item)"/>
                            </template>
                              <template slot="actions" slot-scope="data">
                                  <div v-if="!data.item.loading" class="button green" v-on:click="linkEmployee($event, data)"><div class="label">Hinzufügen</div></div>
                              </template>
                          </b-table>
                      </b-col>
                  </b-row>

                  <br/>
                </div>
            </b-container>

            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next" @click="hideModal('modal-adduser')">
                            <div class="label">Abbrechen</div>
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
      </div>
    </b-modal>


  </div>
</template>

<script>
export default {
  components: {},
  name: "StoreMain",
  data() {
    return {
      // FILTER VARIABLES
      roleFilter: "",
      userFilter: "",
      //LIST ARRAYS
      rolesList: [],
      usersList: [],
      availableUsersList: [],
      availableEmployeesList: [],
      //LIST ARRAYS FILTERED
      rolesFilteredList: [],
      usersFilteredList: [],

      //MAPS FOR LINKING STUFF
      roleMap: {},
      userMap: {},
      userRoleMap: {},

      //HELPERS
      selectedRole: null,
      toDeleteRoleID: null,
      toEditRoleID: null,
      toCreateUserRoleAccountID: null,
      toCreateUserRoleRoleID: null,

      toDeleteUserRoleID: null,
      

      //CREATE/EDIT ELEMENTS
      newRolename: "",
      oldRolename: "",
      roleAlreadyExisting: false,

      //FIELDS FOR THE NEW USER TABLE
      fields: [{
        key: "pic",
        label: "",
        sortable: false,
        thClass: 'documentsTh',
        tdClass: 'documentsTd'
      },
      {
        key: "name",
        sortable: true,
        thClass: 'documentsTh',
        tdClass: 'documentsTd'
      }, {
        key: "email",
        sortable: true,
        thClass: 'documentsTh',
        tdClass: 'documentsTd'
      }, {
        key: "actions",
        label: "",
        sortable: false,
        thClass: 'documentsTh',
        tdClass: 'documentsTd'
      }],
    };
  },
  watch: {
    roleFilter: function(val, oldVal) {
      this.filterRoles();
    },
    userFilter: function(val, oldVal) {
      this.filterUsers();
    },
    newRolename: function(val, oldVal) {
      this.checkRoleExisting();
    }
  },
  props: {},
  created() {
    window.roles = this;
  },
  mounted() {
    this.seconds = new Date().getTime() / 1000;
    let view = this;
    view.refresh();
    this.$store.watch(this.$store.getters.getStoreId, storeId => {
      console.log("Changed storeId: " + storeId);
      if (
        view.$store.state.jwt != undefined &&
        view.$store.state.storeId != undefined
      ) {
        view.refresh();
      }
    });
  },



  updated() {},
  destroyed() {},



  methods: {
    filterRoles(){
      if (this.roleFilter === "") {
        this.rolesFilteredList = this.rolesList.slice();
        return;
      }
      this.rolesFilteredList = this.rolesList.filter(e => e.name.toUpperCase().indexOf(this.roleFilter.toUpperCase()) > -1 || e.id == this.selectedRole.id);
    },
    filterUsers(){
      if (this.userFilter === "") {
        this.usersFilteredList = this.usersList.slice();
        return;
      }
      this.usersFilteredList = this.usersList.filter(e => e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 || e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1);
    },
    filterFilteredUsers(){
      if (this.userFilter === "") {
        this.usersFilteredList = this.usersFilteredList.slice();
        return;
      }
      this.usersFilteredList = this.usersFilteredList.filter(e => e.name.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1 || e.email.toUpperCase().indexOf(this.userFilter.toUpperCase()) > -1);
    },
    sortByName: function(a,b){
      if ( a.name.toUpperCase() < b.name.toUpperCase() ) return -1;
      if ( a.name.toUpperCase() > b.name.toUpperCase() ) return 1;
      return 0;
    },
    checkRoleExisting(){
      this.roleAlreadyExisting = false;
      for (let i = 0; i < this.rolesList.length; i++) {
        if(this.rolesList[i].name.toUpperCase() == this.newRolename.toUpperCase()){
          this.roleAlreadyExisting = true;
          return;
        }
      }
    },
    
    SanitizeInput(input) {
      input = input.replace(/[^A-Za-z0-9 \-]/g, '');
      if (input.length > 32) {
        input = input.substring(0, 32);
      }
      return input;
    },



    hideModal(ref) {
      this.$refs[ref].hide();
    },
    showModal(ref) {
      this.$refs[ref].show();
    },
    openNewRoleWizard() {
      this.showModal("modal-createrole");
    },
    openEditModal: function($event, component, role){
      let view = this;
      // Timeout to prevent race condition with the ToogleRole Event
      setTimeout(function() { 
        if (view.selectedRole == null) {
          view.ToggleRole($event,component,role);
        }
        view.toEditRoleID = role.id;
        view.oldRolename = view.roleMap[view.toEditRoleID].name;
        view.newRolename = view.roleMap[view.toEditRoleID].name;
        view.showModal('modal-editrole');
      }, 200);

    },
    openDeleteModal: function($event, component, role){
      let view = this;
      // Timeout to prevent race condition with the ToogleRole Event
      setTimeout(function() { 
        if (view.selectedRole == null) {
          view.ToggleRole($event,component,role);
        }
        view.toDeleteRoleID = role.id;
        view.showModal('modal-deleterole');
      }, 200);
    },
    openAddUserWizard() {
      this.showModal("modal-adduser");
    },



    ToggleRole($event, component, role) {
      if (this.selectedRole === role) {
        this.selectedRole = null;
      } else {
        this.selectedRole = role;
      }

      for (let i = 0; i < this.usersList.length; i++) {
        if(this.selectedRole != null && this.usersList[i].role && this.usersList[i].role.id != null && this.selectedRole.id == this.usersList[i].role.id){
          this.usersList[i].highlighted = true;
        }else{
          this.usersList[i].highlighted = false;
        }
      }
      this.OrderUsersBySelectedRole(0);
    },
    ToggleUser($event, component, user) {
      if(this.selectedRole == null){
        this.$helpers.warning('Eingabe fehlerhaft', 'Bitte zuerst eine Benutzerrolle auswählen!');
      }else if(this.selectedRole.type == 0){
        this.$helpers.warning('Eingabe fehlerhaft', 'Der Besitzer kann nicht verändert werden!');
      }else if(user.role && user.role.type == 0){
        this.$helpers.warning('Eingabe fehlerhaft', 'Der Besitzer kann nicht verändert werden!');
      }else if(user.role && user.immutable){
        this.$helpers.warning('Eingabe fehlerhaft', 'Dieser Benutzer kann nicht verändert werden!');
      }else if(!user.role || this.selectedRole.id != user.role.id){
        this.toCreateUserRoleAccountID = user.accountId;
        this.toCreateUserRoleRoleID = this.selectedRole.id;
        this.createUserRole();
      }else if(this.selectedRole.id == user.role.id){
        this.toDeleteUserRoleID = user.userRoleID;
        this.deleteUserRole();
      }
    },

    OrderUsersBySelectedRole(filtermethod){
      this.usersList.sort( this.sortByName ); // Maybe not needed, if it's already sorted
      let helperSelected = [];
      let helperNotSelected = [];
      let newArray = this.usersList.slice();
      let j = 0;
      let jj = 0;
      if(this.selectedRole != null){
        newArray = [];
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.usersList[i].role && this.usersList[i].role.id == this.selectedRole.id) {
            helperSelected[j++] = this.usersList[i];
          } else {
            helperNotSelected[jj++] = this.usersList[i];
          }
        }
        newArray = helperSelected.concat(helperNotSelected);
        this.usersList = newArray.slice();
        this.usersFilteredList = newArray.slice();
      }
      if (filtermethod == 0 ? this.filterUsers() : this.filterFilteredUsers());
      this.$forceUpdate();
    },


    refresh() {
      let view = this;

      this.selectedRole = null,
      this.toDeleteRoleID = null,
      this.toEditRoleID = null,
      this.toCreateUserRoleAccountID = null,
      this.toCreateUserRoleRoleID = null,
      this.toDeleteUserRoleID = null,
      this.newRolename = "",
      this.oldRolename = "",
      this.roleAlreadyExisting = false,

      this.loadRoles().then(response => {
        view.updateRoles(response.data); 
        view.filterRoles();
        view.loadUsers().then(response => {
          view.updateUsers(response.data); 
          view.loadUserRoles().then(response => {
            view.updateUserRoles(response.data);
          }).catch(function (error) {
            console.log(error)
          });
        }).catch(function (error) {
          console.log(error)
        });
      }).catch(function (error) {
        console.log(error)
      });
    },



    updateRoles(data){
        let overviewA = [];
        for (let i = 0; i < data.length; i++) {
          let roleItem = {
            id: data[i].id,
            name: data[i].name,
            immutable: data[i].immutable,
            active: data[i].active,
            type: data[i].type,
            letter: data[i].name.charAt(0).toUpperCase(),
            //color: "#"+roles.intToRGB(roles.hashCode(data[i].name)),
            color: "var(--contrast-1)",
          };
          this.roleMap[data[i].id] = roleItem;
          overviewA.push(roleItem);
        }
        this.rolesList = overviewA;
        this.rolesList.sort( this.sortByName );
        this.rolesFilteredList = this.rolesList.slice();
        this.$forceUpdate();
    },

    updateUsers(data){
        let overviewUsers = [];
        let overviewEmployees = [];
        for (let i = 0; i < data.length; i++) {
            let user = {
              accountId: data[i].accountId,
              employeeId: data[i].employeeId,
              name: data[i].firstName +" "+data[i].lastName,
              firstname: data[i].firstName,
              lastname: data[i].lastName,
              profileImage: data[i].profileImage,
              email: data[i].email,
              type: data[i].type,
            };

            if(data[i].accountId != null){
                this.userMap[data[i].accountId] = user;
                overviewUsers.push(user);
            }else{
                overviewEmployees.push(user);
            }
        }
        
        this.usersList = overviewUsers;
        this.usersList.sort( this.sortByName );
        this.usersFilteredList = this.usersList.slice();

        this.availableEmployeesList = overviewEmployees;
        this.availableEmployeesList.sort( this.sortByName );
        this.$forceUpdate();
    },

    updateUserRoles(data){
        let overviewA = [];
        for (let i = 0; i < data.length; i++) {
            if(this.userMap[data[i].accountId] != undefined /*&& this.roleMap[data[i].roleId] != undefined*/){
                let userRoleItem = {
                    id: data[i].id,
                    accountId: data[i].accountId,
                    immutable: data[i].immutable,
                    role: this.roleMap[data[i].roleId],
                }
                this.userRoleMap[data[i].id] = userRoleItem; 
                overviewA.push(userRoleItem);
            }
        }



        for (let i = 0; i < this.usersList.length; i++) {
          for (let j = 0; j < overviewA.length; j++) {
            if(overviewA[j].accountId == this.usersList[i].accountId){
              this.usersList[i].userRoleID = overviewA[j].id;
              this.usersList[i].immutable = overviewA[j].immutable;
              this.usersList[i].role = overviewA[j].role;
            }
          }
        }
        this.usersFilteredList = this.usersList.slice();
        this.$forceUpdate();
    },










    createRole: function(evt){
        evt.preventDefault();
        //this.error=false;
        let view = this;
        let url = '/api/sec/role';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/role');

        let payload = {
          storeId: this.$store.state.storeId,
          name: this.newRolename
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
          this.newRolename = "";
            let letter = response.data.data.name.charAt(0).toUpperCase();
            let roleItem = {
                id: response.data.data.id,
                name: response.data.data.name,
                immutable: response.data.data.immutable,
                active: response.data.data.active,
                letter: letter,
                /*color: "#"+roles.intToRGB(roles.hashCode(response.data[i].name)),*/
                color: "var(--contrast-1)",
            }
            
            view.roleMap[response.data.data.id] = roleItem;
            view.rolesList.push(roleItem);
            view.rolesList.sort( roles.sortByName );
            view.rolesFilteredList = view.rolesList.slice();
            view.filterRoles();
            view.$forceUpdate();
            view.hideModal('modal-createrole');
            this.$helpers.success('Erfolg', 'Eine neue Rolle wurde angelegt!');
        }).catch(function (error) {
            //view.error=true;
            console.log(error)
        })

    },
    updateRole: function(evt){
        evt.preventDefault();
        //this.error=false;
        let view = this;
        let url = '/api/sec/role';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/role');

        let payload = {
          storeId: this.$store.state.storeId,
          id: this.toEditRoleID,
          updateFields: []
        }

        if(this.oldRolename != this.newRolename){
            payload.name = this.newRolename;
            payload.updateFields.push("name");
        }
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.refresh();
            view.hideModal('modal-editrole');
            this.$helpers.success('Erfolg', 'Eine Rolle wurde bearbeitet!');
        }).catch(function (error) {
            //view.error=true;
            console.log(error)
        })

    },
    deleteRole: function(evt){
        evt.preventDefault();
        //this.error=false;
        let view = this;
        let url = '/api/sec/role';
        url = this.$helpers.appendParam("id", this.toDeleteRoleID, url, '/api/sec/role');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/role');
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.rolesList.findIndex(role =>role.id === view.toDeleteRoleID) 
            if (~index) {
              if(view.rolesList[index].id == view.selectedRole.id){
                view.selectedRole = null;
              }
              view.rolesList.splice(index, 1);
              view.rolesFilteredList = view.rolesList.slice();
            }
            view.deleteRoleFromMap(view.toDeleteRoleID);   
            view.hideModal('modal-deleterole');
            this.$helpers.success('Erfolg', 'Eine Rolle wurde gelöscht!');
        }).catch(function (error) {
            //view.error=true;
            console.log(error)
        })
    },





    linkEmployee: function(evt,data){
        evt.preventDefault();
        //this.employeeerror=false;
        let view = this;


            for (let i = 0; i < view.availableEmployeesList.length; i++) {
              if(data.item.employeeId == view.availableEmployeesList[i].employeeId){
                  view.availableEmployeesList[i].loading = true;
              }
            }
        view.$forceUpdate();


        let url = '/api/sec/employee/linkaccount';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/linkaccount');
        url = this.$helpers.appendParam("id", data.item.employeeId, url, '/api/sec/employee/linkaccount');

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {        
          data.item.accountId = response.data.data;
          view.usersList.push(data.item);
          view.usersList.sort( view.sortByName );
          view.filterUsers()

            for (let i = 0; i < view.availableEmployeesList.length; i++) {
              if(data.item.employeeId == view.availableEmployeesList[i].employeeId){
                  view.availableEmployeesList.splice(i, 1);
              }
            }
          this.$helpers.success('Erfolg', 'Mitarbeiter Account wurde verlinkt.');
        }).catch(function (error) {
            //view.employeeerror=true;
            console.log(error)
        })
    },
    createUserRole: function(){
        let view = this;
        let url = '/api/sec/userrole';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userrole');

        let payload = {
          accountId: this.toCreateUserRoleAccountID,
          roleId: this.toCreateUserRoleRoleID
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let data = response.data.data;
            let userRoleItem = {
              id: data.id,
              accountId: data.accountId,
              immutable: data.immutable,
              role: view.roleMap[data.roleId]
            }
            view.userRoleMap[data.id] = userRoleItem;


          for (let i = 0; i < view.usersList.length; i++) {
            if(data.accountId == view.usersList[i].accountId){
              view.usersList[i].userRoleID = data.id;
              view.usersList[i].immutable = data.immutable;
              view.usersList[i].role = view.roleMap[data.roleId];
              view.usersList[i].highlighted = true;
            }
          }
        view.$forceUpdate();
        view.OrderUsersBySelectedRole(1);
        this.$helpers.success('Erfolg', 'Benutzerrolle wurde zugewiesen');

        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteUserRole: function(){
        let view = this;
        let url = '/api/sec/userrole';
        url = this.$helpers.appendParam("id", this.toDeleteUserRoleID, url, '/api/sec/userrole');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userrole');
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {

/*
            const index = view.userRoles.findIndex(userRole => userRole.accountId === payload.accountId && userRole.immutable === false) 
            if (~index) {
                let userRoleId = view.userRoles[index].id;
                view.userRoles.splice(index, 1);
                view.deleteUserRoleFromMap(userRoleId);  
            }*/

          for (let i = 0; i < view.usersList.length; i++) {
            if(view.toDeleteUserRoleID == view.usersList[i].userRoleID){
              view.usersList[i].userRoleID = null;
              view.usersList[i].immutable = null;
              view.usersList[i].role = null;
              view.usersList[i].highlighted = false;
            }
          }
        view.$forceUpdate();
        view.OrderUsersBySelectedRole(1);


            this.$helpers.success('Erfolg', 'Benutzerrolle wurde entfernt');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },

    deleteRoleFromMap(id){
        let key = null;
        /*for(key in this.rolePermissionMap){
            if(this.rolePermissionMap[key].roleId === id){
                this.deleteRolePermissionFromMap(key);
            }
        }*/
        for(key in this.userRoleMap){
            if(this.userRoleMap[key].roleId === id){
                this.deleteUserRoleFromMap(key);
            }
        } 
        delete this.roleMap[id];
    },
    deleteRolePermissionFromMap(id){
        delete this.rolePermissionMap[id]
    },
    deleteUserRoleFromMap(id){
        delete this.userRoleMap[id]
    },




    










    loadRoles() {
      let url = "/api/sec/role";
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/role');
      return this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt
        },
        url: url
      });
    },
    loadUsers() {
      let url = '/api/sec/user';
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/user');
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/user');
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      })
    },
    loadUserRoles() {
      let url = '/api/sec/userrole';
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/userrole');
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      })
    },
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    GetProfilePictureCSS(user){
      if(!user.profileImage) return 'var(--contrast-1) no-repeat center/cover  url(https://fileserver1.meindienstplan.de:8443/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S)';
      return 'var(--contrast-1) no-repeat center/cover  url(' + user.profileImage + ')';
      },
    GetProfilePicture(user){
      if(!user.profileImage) return 'https://fileserver1.meindienstplan.de:8443/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S';
      return user.profileImage;
      },
    hashCode(str) {
      // java String#hashCode
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    },
    intToRGB(i) {
      let c = (i & 0x00ffffff).toString(16).toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    },
  }
};
</script>
















<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.half-width {
  width: 50%;
}

.fix-button-width {
  width: 150px;
}

.adjust-input {
  margin-left: -50px;
  padding-left: 30px;
  width: calc(100% - 200px);
}

.list {
  width: calc(100% - 78px);
  margin: auto;
  height: 265px;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  overflow: hidden;
  position: absolute;
  border-radius: 5px;
}
.list .scroll-content {
  padding: 5px;
  overflow-y: auto;
  height: 265px;
}

.list-entry {
  height: 35px;
  margin-bottom: 2px;
  border-radius: 100px;
  cursor: pointer;
}


.list-entry:hover {
  background: var(--sub-menu);
  cursor: pointer;
}
.list-entry.selected {
  background: #6d8d23;
  cursor: pointer;
}
.list-entry.selected > .label,
.list-entry:hover > .label{
  color: var(--bg);
  cursor: pointer;
}
.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
  color: var(--bg) !important;
  cursor: pointer;
}


.list-entry > .label {
  float: left;
  font-size: 14px;
  font-family: DistrictProBook;
  color: var(--contrast-4);
  padding-top: 6px;
  cursor: pointer;
}
.list-entry > .label > .label-small {
  cursor: pointer;
  color:var(--contrast-5);
}


.picture {
  float: left;
  border-radius: 100px;
  background: var(--contrast-1);
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
}
.position-right{
  float: right;
  margin: 0;
  margin-right: -5px;
}
.pictureImg {
  border-radius: 100px;
  height: 25px;
  width: 25px;
}





/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--contrast-1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--contrast-3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #aaaaaa;
}
</style>